const signatureTypes = Object.freeze({
  Handwritten: 0,
  Electronic: 1,
});

const signatureTypeLabels = Object.freeze({
  Handwritten: 'Manuscrita',
  Electronic: 'Electrónica',
});

export { signatureTypes, signatureTypeLabels };
